import { FC } from "react";
import { CreateChallengeFormTypes } from "../../utils/CreateChallengeTypes";
import {
  Box,
  Button,
  Callout,
  Card,
  Flex,
  Heading,
  Spinner,
  Text,
} from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

export const CreateChallengeHeader: FC<{
  isEdit: boolean;
  step: number;
  stepsAmount: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  handleNextStep: () => Promise<false | void>;
  values: CreateChallengeFormTypes;
}> = ({
  isEdit,
  step,
  setStep,
  loading,
  stepsAmount,
  values,
  handleNextStep,
}) => {
  return (
    <>
      {step + 1 !== stepsAmount ? (
        <Box mb="5">
          <Heading as="h1" my="0">
            {isEdit ? "Edit" : "New"} Challenge
          </Heading>
          <Text color="gray" size="2">{`Step ${step + 1}/${stepsAmount}`}</Text>
        </Box>
      ) : (
        <Box
          position="fixed"
          inset="auto 1rem 1rem auto"
          style={{ zIndex: "9999" }}
          asChild
        >
          <Card>
            <Flex direction="column" gap="3">
              {isEdit ? (
                <Text size="3">Is {values.name} ready to be updated?</Text>
              ) : (
                <Text size="3">Is {values.name} ready to go live?</Text>
              )}
              <Flex gap="3" justify="between">
                {!loading && (
                  <Button
                    variant="solid"
                    disabled={loading}
                    onClick={() => handleNextStep()}
                  >
                    {isEdit ? <>Yes, update</> : <>Yes, activate</>}
                  </Button>
                )}
                <Button
                  variant="soft"
                  onClick={() => setStep((s) => s - 1)}
                  disabled={loading}
                >
                  Go back
                </Button>
                <>{loading && <Spinner />}</>
              </Flex>
            </Flex>
          </Card>
        </Box>
      )}
    </>
  );
};
